import React from 'react';
import {useDashboard} from './context';

/** A small colored phase chip. Ported verbatim from the prototype. */
export function PhasePill({phase, small}: {phase: string; small?: boolean}): React.ReactElement {
  const {phaseColors} = useDashboard();
  const c = phaseColors[phase] || {pill: '#F1F5F9', text: '#64748B', border: '#E2E8F0'};
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: small ? '1px 6px' : '2px 8px',
        borderRadius: 20,
        background: c.pill,
        color: c.text,
        border: `1px solid ${c.border}`,
        fontSize: small ? 9 : 10,
        fontWeight: 700,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap'
      }}
    >
      {phase}
    </span>
  );
}
